"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import PageLoading from "./PageLoading/PageLoading";

export default function RouteLoader() {
  const pathname = usePathname();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Scroll to top using requestAnimationFrame for better timing
    if (typeof window !== "undefined") {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      });
    }

    setLoading(true);

    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1000); 

    return () => clearTimeout(timeout);
  }, [pathname]);

  if (!loading) return null;

  return (
    <div className="page-loader-tran">
      <PageLoading />
    </div>
  );
}

// "use client";

// import { useEffect, useState } from "react";
// import { usePathname } from "next/navigation";
// import PageLoading from "./PageLoading/PageLoading";

// export default function RouteLoader() {
//   const pathname = usePathname();
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     window.scrollTo(0, 0);

//     setLoading(true);

//     const timeout = setTimeout(() => {
//       setLoading(false);
//     }, 1000);

//     return () => clearTimeout(timeout);
//   }, [pathname]);

//   if (!loading) return null;

//   return (
//     <div className="page-loader-tran">
//       <PageLoading />
//     </div>
//   );
// }
